import React, { useEffect, useState } from 'react';
import {
  renderCheckboxes,
  renderDropdown,
  renderDropdownWithoutLabel,
  renderDropwdownWithCheckbox,
  renderInputFieldWithoutLabel,
} from '../../../../common/inputField';
import { useDispatch, useSelector } from 'react-redux';
import { setEmbryologyData } from '../../../../actions/embryologyActions';
import DateComponent from '../../../Registrationform/components/dateComponent';
import { IconButton, TextField } from '@mui/material';
import { fetchEmbryologyOocyteEmbryoRecord } from '../../../../api/embryologyApi';
import dayjs from 'dayjs';
import { toast } from 'sonner';
import {
  day0Row,
  day1Row,
  day2Row,
  day3Row,
  day4Row,
  day5Row,
  day6Row,
} from '../../../../reducers/embryologyReducer';
import EmbryologyOocyteImageModal from './EmbryologyOocyteModal';
import DeleteIcon from '@mui/icons-material/Delete';
import UIModal from '../../../../components/UIElements/UIModal';

const EmbryologyOocyteEmbryoRecord = ({ cycleId, isDisabled }) => {
  const [day, setDay] = useState([
    {
      name: 'Day 1',
      label: 'Day 1',
      checked: true,
    },
    {
      name: 'Day 2',
      label: 'Day 2',
      checked: true,
    },
    {
      name: 'Day 3',
      label: 'Day 3',
      checked: false,
    },
    {
      name: 'Day 4',
      label: 'Day 4',
      checked: false,
    },
    {
      name: 'Day 5',
      label: 'Day 5',
      checked: false,
    },
    {
      name: 'Day 6',
      label: 'Day 6',
      checked: false,
    },
    {
      name: 'Full',
      label: 'Fate',
      checked: false,
    },
  ]);

  const [loading, setLoading] = useState(false);
  const [imageModal, setImageModal] = useState({
    open: false,
    day: null,
    index: null,
  });

  const [confirmModal, setConfirmModal] = useState({
    open: false,
    index: null,
  });

  const data = useSelector((state) => state.embryologyReducer);
  const oocyteData = useSelector(
    (state) => state.embryologyReducer.oocyteEmbryo,
  );
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchSummary = async () => {
      const response = await fetchEmbryologyOocyteEmbryoRecord(
        data.selectedPatientData.patient.id,
        cycleId,
      );

      if (!response.data.result) {
        if (response.data.summary && response.data.summary.summary) {
          const summary = response.data.summary.summary;
          const ivfCount = summary.ivfCoc ? parseInt(summary.ivfCoc) : 1;
          const icsiCount = summary.icsiMii ? parseInt(summary.icsiMii) : 1;
          const data = [[], [], [], [], [], [], []];
          for (let i = 0; i < ivfCount + icsiCount; i++) {
            for (let j = 0; j <= 6; j++) {
              data[j].push(getEmptyRow(j));
            }
            data[0][i].type = i < ivfCount ? 'IVF' : 'ICSI';
          }
          for (let i = 0; i <= 6; i++) {
            dispatch(setEmbryologyData(`oocyteEmbryo.day${i}.data`, data[i]));
          }
        }
      } else {
        dispatch(
          setEmbryologyData('oocyteEmbryo', response.data.result.oocyteEmbryo),
        );
        dispatch(setEmbryologyData('oocyteEmbryo.id', response.data.result.id));
        toast.success('Data fetched');
      }
    };
    fetchSummary();
  }, []);
  const handleInputChange = (e) => {
    if (isDisabled) return;
    const { name, value } = e.target;
    dispatch(setEmbryologyData(`oocyteEmbryo.${name}`, value));
  };

  const handleDateChange = (day, name, index) => {
    if (isDisabled) return;
    dispatch(setEmbryologyData(`oocyteEmbryo.day${index}.${name}`, day));
    if (index === 0) {
      dispatch(
        setEmbryologyData(
          `oocyteEmbryo.day1.date`,
          dayjs(day).add(1, 'day').format('YYYY-MM-DD'),
        ),
      );
      dispatch(
        setEmbryologyData(
          `oocyteEmbryo.day2.date`,
          dayjs(day).add(2, 'day').format('YYYY-MM-DD'),
        ),
      );
      dispatch(
        setEmbryologyData(
          `oocyteEmbryo.day3.date`,
          dayjs(day).add(3, 'day').format('YYYY-MM-DD'),
        ),
      );
      dispatch(
        setEmbryologyData(
          `oocyteEmbryo.day4.date`,
          dayjs(day).add(4, 'day').format('YYYY-MM-DD'),
        ),
      );
      dispatch(
        setEmbryologyData(
          `oocyteEmbryo.day5.date`,
          dayjs(day).add(5, 'day').format('YYYY-MM-DD'),
        ),
      );
      dispatch(
        setEmbryologyData(
          `oocyteEmbryo.day6.date`,
          dayjs(day).add(6, 'day').format('YYYY-MM-DD'),
        ),
      );
    }
  };

  const getEmptyRow = (index) => {
    switch (index) {
      case 0:
        return { ...day0Row };
      case 1:
        return { ...day1Row };
      case 2:
        return { ...day2Row };
      case 3:
        return { ...day3Row };
      case 4:
        return { ...day4Row };
      case 5:
        return { ...day5Row };
      case 6:
        return { ...day6Row };
      default:
        return [];
    }
  };

  const handleAddRow = () => {
    if (isDisabled) return;
    for (let i = 0; i <= 6; i++) {
      const copyRows = [...oocyteData[`day${i}`].data];
      copyRows.push(getEmptyRow(i));
      dispatch(setEmbryologyData(`oocyteEmbryo.day${i}.data`, copyRows));
    }
  };

  const handleDeleteRow = (index) => {
    if (isDisabled) return;
    for (let i = 0; i <= 6; i++) {
      const copyRows = [...oocyteData[`day${i}`].data];
      copyRows.splice(index, 1);
      dispatch(setEmbryologyData(`oocyteEmbryo.day${i}.data`, copyRows));
    }
  };
  const handleRowInputChange = (e, index) => {
    if (isDisabled) return;
    const { name, value } = e.target;

    const day = name.split('.')[0];
    const field = name.split('.')[2];
    const copyRows = [...oocyteData[`${day}`].data];
    copyRows[index][field] = value === ' ' ? '' : value;
    dispatch(setEmbryologyData(`oocyteEmbryo.${day}.data`, copyRows));
    setDayAndCellGrade(index);
  };

  const setDayAndCellGrade = (index) => {
    if (
      oocyteData.day6.data[index].innerCellMassGrade !== '' &&
      oocyteData.day6.data[index].trophectodermGrade !== '' &&
      oocyteData.day6.data[index].expansion !== ''
    ) {
      const copyRows = [...oocyteData.day6.data];
      copyRows[index].day = '6';
      copyRows[index].cellNoOrGrade =
        `${oocyteData.day6.data[index].expansion} ${oocyteData.day6.data[index].innerCellMassGrade}${oocyteData.day6.data[index].trophectodermGrade}`;

      dispatch(setEmbryologyData(`oocyteEmbryo.day6.data`, copyRows));
    } else if (
      oocyteData.day5.data[index].innerCellMassGrade !== '' &&
      oocyteData.day5.data[index].trophectodermGrade !== '' &&
      oocyteData.day5.data[index].expansion !== ''
    ) {
      const copyRows = [...oocyteData.day6.data];
      copyRows[index].day = '5';
      copyRows[index].cellNoOrGrade =
        `${oocyteData.day5.data[index].expansion} ${oocyteData.day5.data[index].innerCellMassGrade}${oocyteData.day5.data[index].trophectodermGrade}`;
      dispatch(setEmbryologyData(`oocyteEmbryo.day6.data`, copyRows));
    } else if (
      oocyteData.day4.data[index].grade !== '' &&
      oocyteData.day4.data[index].stage !== ''
    ) {
      const copyRows = [...oocyteData.day6.data];
      copyRows[index].day = '4';
      copyRows[index].cellNoOrGrade =
        `${oocyteData.day4.data[index].stage} ${oocyteData.day4.data[index].grade}`;
      dispatch(setEmbryologyData(`oocyteEmbryo.day6.data`, copyRows));
    } else if (
      oocyteData.day3.data[index].cell !== '' &&
      oocyteData.day3.data[index].grade !== ''
    ) {
      const copyRows = [...oocyteData.day6.data];
      copyRows[index].day = '3';
      copyRows[index].cellNoOrGrade =
        `${oocyteData.day3.data[index].cell} ${oocyteData.day3.data[index].grade}`;
      dispatch(setEmbryologyData(`oocyteEmbryo.day6.data`, copyRows));
    }
  };

  // const handleFateChange = (e, index, row) => {
  //   const { checked } = e.target;
  //   const updatedCheckboxes = oocyteData.day6.data[row].fate.map((item, idx) =>
  //     idx === index ? { ...item, checked } : item,
  //   );

  //   const copyRows = [...oocyteData.day6.data];
  //   copyRows[row].fate = updatedCheckboxes;
  //   dispatch(setEmbryologyData(`oocyteEmbryo.day6.data`, copyRows));
  // };

  const handleTimeChange = (value, name, index) => {
    if (isDisabled) return;
    dispatch(setEmbryologyData(`oocyteEmbryo.day${index}.${name}`, value));
  };

  const handleDayChange = (e, index) => {
    const { name, checked } = e.target;
    const updatedCheckboxes = day.map((item, idx) =>
      idx === index ? { ...item, checked } : item,
    );

    setDay(updatedCheckboxes);
  };

  return (
    <div className="customer-profile">
      <h3 style={{ textAlign: 'center' }}>Oocyte Embryo Record</h3>
      {renderCheckboxes(day, handleDayChange, 'Select Day')}
      {/* {renderDropdown(
        'Select Day',
        'day',
        day === 'Full' ? 'Full' : `Day ${day}`,
        ['Day 1', 'Day 2', 'Day 3', 'Day 4', 'Day 5', 'Day 6', 'Full'],
        (e) =>
          setDay(
            e.target.value === 'Full' ? 'Full' : e.target.value.split(' ')[1],
          ),
      )} */}

      <div className="body" style={{ display: 'flex', overflow: 'auto' }}>
        <table
          className="oocyte-embryo-table"
          cellPadding={'20px'}
          style={{
            flexGrow: 1,
            padding: '0px 10px',
            top: '0px',
            left: '0px',
            position: 'sticky',
            zIndex: 100,
          }}
        >
          <thead>
            <tr>
              <th colSpan={2} style={{ border: '0px' }}>
                <div style={{ height: '244px' }}></div>
              </th>
            </tr>
          </thead>
          <tbody style={{ backgroundColor: 'white' }}>
            <tr>
              <td>
                <div style={{ height: '20px' }}>Egg</div>
              </td>
              <td>
                <div style={{}}>Type of Fertilisation</div>
              </td>
            </tr>
            {oocyteData.day0.data.map((row, index) => (
              <tr key={index}>
                <td>
                  <div style={{ width: '10px' }}>{index + 1}</div>
                </td>
                <td>
                  {renderDropdownWithoutLabel(
                    `day0.data[${index}].type`,
                    row.type,
                    [' ', 'IVF', 'ICSI'],
                    handleRowInputChange,
                    index,
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <table
          className="oocyte-embryo-table"
          cellPadding={'20px'}
          style={{ flexGrow: 1, padding: '0px 10px' }}
        >
          <thead>
            <tr>
              <th colSpan={3}>Day 0</th>
            </tr>
            <tr>
              <th colSpan={1}>Date:</th>
              <th colSpan={2}>
                <DateComponent
                  id="embryologyDate"
                  selectedDate={
                    oocyteData.day0.date ? dayjs(oocyteData.day0.date) : null
                  }
                  handleDateChange={(date, dateString) =>
                    handleDateChange(date, 'date', 0)
                  }
                />
              </th>
            </tr>
            <tr>
              <th colSpan={1}>Incubator:</th>
              <th colSpan={2}>
                {renderInputFieldWithoutLabel(
                  'day0.incubator',
                  oocyteData.day0.incubator,
                  handleInputChange,
                )}
              </th>
            </tr>
            <tr>
              <th colSpan={1}>Sci:</th>
              <th colSpan={2}>
                {renderInputFieldWithoutLabel(
                  'day0.sci',
                  oocyteData.day0.sci,
                  handleInputChange,
                )}{' '}
              </th>
            </tr>
            <tr>
              <th colSpan={1}>Witness: </th>
              <th colSpan={2}>
                {renderInputFieldWithoutLabel(
                  'day0.witness',
                  oocyteData.day0.witness,
                  handleInputChange,
                )}{' '}
              </th>
            </tr>
            <tr>
              <th colSpan={1}>Time:</th>
              <th colSpan={2}>
                <TextField
                  type="time"
                  variant="standard"
                  value={oocyteData.day0.time}
                  onChange={(e) => handleTimeChange(e.target.value, 'time', 0)}
                />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div
                  style={{ height: '40px', marginTop: '15px', width: '70px' }}
                >
                  Maturity
                </div>
              </td>
              <td>
                <div style={{ width: '130px' }}>Quality</div>
              </td>
              <td>
                <div style={{ width: '130px' }}>Comments</div>
              </td>
              <td>Image</td>
            </tr>
            {oocyteData.day0.data.map((row, index) => (
              <tr key={index}>
                <td>
                  {renderDropdownWithoutLabel(
                    `day0.data[${index}].maturity`,
                    row.maturity,
                    [' ', 'MII', 'MI', 'GV', 'ABNORMAL', 'OTHER'],
                    handleRowInputChange,
                    index,
                  )}
                </td>
                <td>
                  {renderDropdownWithoutLabel(
                    `day0.data[${index}].comm`,
                    row.comm,
                    [
                      ' ',
                      'Granulation',
                      'Central Granulation',
                      'SER Body',
                      'Vacuoles',
                      'LPVS',
                      'Thick ZP',
                      'Dark Oocyte',
                      'Referactile Body',
                      'Debris in PVS',
                      'Fragmented Oocyte',
                      'Other',
                    ],
                    handleRowInputChange,
                    index,
                  )}
                </td>
                <td>
                  {renderInputFieldWithoutLabel(
                    `day1.data[${index}].comments`,
                    row.comments,
                    (e) => handleRowInputChange(e, index),
                  )}
                </td>
                <td>
                  <button
                    className="btn btn-primary"
                    style={{}}
                    onClick={() => setImageModal({ open: true, day: 0, index })}
                  >
                    {`View ${row.image.length} Image(s)`}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {day[0].checked && (
          <table
            className="oocyte-embryo-table"
            cellPadding={'20px'}
            style={{ flexGrow: 1, padding: '0px 10px' }}
          >
            <thead>
              <tr>
                <th colSpan={4}>Day 1</th>
              </tr>
              <tr>
                <th colSpan={2}>Date:</th>
                <th colSpan={2}>
                  <DateComponent
                    id="embryologyDate"
                    selectedDate={
                      oocyteData.day1.date ? dayjs(oocyteData.day1.date) : null
                    }
                    handleDateChange={(date, dateString) =>
                      handleDateChange(date, 'date', 1)
                    }
                  />
                </th>
              </tr>
              <tr>
                <th colSpan={4}>
                  <div style={{ height: '41px' }}></div>
                </th>
              </tr>
              <tr>
                <th colSpan={2}>Sci: </th>
                <th colSpan={2}>
                  {renderInputFieldWithoutLabel(
                    'day1.sci',
                    oocyteData.day1.sci,
                    handleInputChange,
                  )}{' '}
                </th>
              </tr>
              <tr>
                <th colSpan={2}>Witness: </th>
                <th colSpan={2}>
                  {renderInputFieldWithoutLabel(
                    'day1.witness',
                    oocyteData.day1.witness,
                    handleInputChange,
                  )}{' '}
                </th>
              </tr>
              <tr>
                <th colSpan={2}>Time:</th>
                <th colSpan={2}>
                  <TextField
                    type="time"
                    variant="standard"
                    value={oocyteData.day1.time}
                    onChange={(e) =>
                      handleTimeChange(e.target.value, 'time', 1)
                    }
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div
                    style={{ height: '40px', marginTop: '15px', width: '60px' }}
                  >
                    PN
                  </div>
                </td>
                <td>
                  <div style={{ width: '60px' }}>PB</div>
                </td>
                <td>
                  <div style={{ width: '100px' }}>Comm.</div>
                </td>
                <td>Image</td>
              </tr>
              {oocyteData.day1.data.map((row, index) => (
                <tr key={index}>
                  <td>
                    {renderDropdownWithoutLabel(
                      `day1.data[${index}].pn`,
                      row.pn,
                      [' ', '>3', '3', '2', '1', '0', 'Degenerated'],
                      handleRowInputChange,
                      index,
                    )}
                  </td>
                  <td>
                    {renderDropdownWithoutLabel(
                      `day1.data[${index}].pb`,
                      row.pb,
                      [' ', '>3', '3', '2', '1', '0'],
                      handleRowInputChange,
                      index,
                    )}
                  </td>
                  <td>
                    {renderInputFieldWithoutLabel(
                      `day1.data[${index}].comm`,
                      row.comm,
                      (e) => handleRowInputChange(e, index),
                    )}
                  </td>
                  <td>
                    <button
                      className="btn btn-primary"
                      style={{}}
                      onClick={() =>
                        setImageModal({ open: true, day: 1, index })
                      }
                    >
                      {`View ${row.image.length} Image(s)`}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {day[1].checked && (
          <table
            className="oocyte-embryo-table"
            cellPadding={'20px'}
            style={{ flexGrow: 1, padding: '0px 10px' }}
          >
            <thead>
              <tr>
                <th colSpan={5}>Day 2</th>
              </tr>
              <tr>
                <th colSpan={2}>Date:</th>
                <th colSpan={3}>
                  <DateComponent
                    id="embryologyDate"
                    selectedDate={
                      oocyteData.day2.date ? dayjs(oocyteData.day2.date) : null
                    }
                    handleDateChange={(date, dateString) =>
                      handleDateChange(date, 'date', 2)
                    }
                  />
                </th>
              </tr>
              <tr>
                <th colSpan={5}>
                  <div style={{ height: '41px' }}></div>
                </th>
              </tr>
              <tr>
                <th colSpan={2}>Sci: </th>
                <th colSpan={3}>
                  {renderInputFieldWithoutLabel(
                    'day2.sci',
                    oocyteData.day2.sci,
                    handleInputChange,
                  )}{' '}
                </th>
              </tr>
              <tr>
                <th colSpan={2}>Witness: </th>
                <th colSpan={3}>
                  {renderInputFieldWithoutLabel(
                    'day2.witness',
                    oocyteData.day2.witness,
                    handleInputChange,
                  )}{' '}
                </th>
              </tr>
              <tr>
                <th colSpan={2}>Time:</th>
                <th colSpan={3}>
                  <TextField
                    type="time"
                    variant="standard"
                    value={oocyteData.day2.time}
                    onChange={(e) =>
                      handleTimeChange(e.target.value, 'time', 2)
                    }
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div
                    style={{ height: '40px', marginTop: '15px', width: '60px' }}
                  >
                    Cell#
                  </div>
                </td>
                <td>
                  <div style={{ width: '70px' }}>Grade</div>
                </td>
                <td>
                  <div style={{ width: '70px' }}>Frag</div>
                </td>
                <td>
                  <div style={{ width: '100px' }}>Comm</div>
                </td>
                <td>Image</td>
              </tr>
              {oocyteData.day2.data.map((row, index) => (
                <tr key={index}>
                  <td>
                    {renderDropdownWithoutLabel(
                      `day2.data[${index}].cell`,
                      row.cell,
                      [' ', '8', '7', '6', '5', '4', '3', '2', 'Not Cleaved'],
                      handleRowInputChange,
                      index,
                    )}
                  </td>
                  <td>
                    {renderDropdownWithoutLabel(
                      `day2.data[${index}].grade`,
                      row.grade,
                      [' ', 'A', 'B', 'C'],
                      handleRowInputChange,
                      index,
                    )}
                  </td>
                  <td>
                    {renderDropdownWithoutLabel(
                      `day2.data[${index}].frag`,
                      row.frag,
                      [' ', '0', '5', '10', '15', '20', '>20'],
                      handleRowInputChange,
                      index,
                    )}
                  </td>
                  <td>
                    {renderInputFieldWithoutLabel(
                      `day2.data[${index}].comm`,
                      row.comm,
                      (e) => handleRowInputChange(e, index),
                    )}
                  </td>
                  <td>
                    <button
                      className="btn btn-primary"
                      style={{}}
                      onClick={() =>
                        setImageModal({ open: true, day: 2, index })
                      }
                    >
                      {`View ${row.image.length} Image(s)`}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {day[2].checked && (
          <table
            className="oocyte-embryo-table"
            cellPadding={'20px'}
            style={{ flexGrow: 1, padding: '0px 10px' }}
          >
            <thead>
              <tr>
                <th colSpan={4}>Day 3</th>
              </tr>
              <tr>
                <th colSpan={2}>Date:</th>
                <th colSpan={2}>
                  <DateComponent
                    id="embryologyDate"
                    selectedDate={
                      oocyteData.day3.date ? dayjs(oocyteData.day3.date) : null
                    }
                    handleDateChange={(date, dateString) =>
                      handleDateChange(date, 'date', 3)
                    }
                  />
                </th>
              </tr>
              <tr>
                <th colSpan={4}>
                  <div style={{ height: '41px' }}></div>
                </th>
              </tr>
              <tr>
                <th colSpan={2}>Sci:</th>
                <th colSpan={2}>
                  {renderInputFieldWithoutLabel(
                    'day3.sci',
                    oocyteData.day3.sci,
                    handleInputChange,
                  )}{' '}
                </th>
              </tr>
              <tr>
                <th colSpan={2}>Witness: </th>
                <th colSpan={2}>
                  {renderInputFieldWithoutLabel(
                    'day3.witness',
                    oocyteData.day3.witness,
                    handleInputChange,
                  )}{' '}
                </th>
              </tr>
              <tr>
                <th colSpan={2}>Time:</th>
                <th colSpan={2}>
                  <TextField
                    type="time"
                    variant="standard"
                    value={oocyteData.day3.time}
                    onChange={(e) =>
                      handleTimeChange(e.target.value, 'time', 3)
                    }
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div
                    style={{
                      height: '40px',
                      marginTop: '15px',
                      width: '120px',
                    }}
                  >
                    Cell#
                  </div>
                </td>
                <td>
                  <div style={{ width: '60px' }}>Grade</div>
                </td>
                <td>
                  <div style={{ width: '100px' }}>Comm</div>
                </td>
                <td>Image</td>
              </tr>
              {oocyteData.day3.data.map((row, index) => (
                <tr key={index}>
                  <td>
                    {renderDropdownWithoutLabel(
                      `day3.data[${index}].cell`,
                      row.cell,
                      [
                        ' ',
                        'Arrested',
                        '10+',
                        '10',
                        '9',
                        '8',
                        '7',
                        '6',
                        '5',
                        '4',
                        '3',
                        'Early Morula',
                        'Morula',
                      ],
                      handleRowInputChange,
                      index,
                    )}
                  </td>
                  <td>
                    {renderDropdownWithoutLabel(
                      `day3.data[${index}].grade`,
                      row.grade,
                      [' ', 'A', 'B', 'C'],
                      handleRowInputChange,
                      index,
                    )}
                  </td>
                  <td>
                    {renderInputFieldWithoutLabel(
                      `day3.data[${index}].comm`,
                      row.comm,
                      (e) => handleRowInputChange(e, index),
                    )}
                  </td>
                  <td>
                    <button
                      className="btn btn-primary"
                      style={{}}
                      onClick={() =>
                        setImageModal({ open: true, day: 3, index })
                      }
                    >
                      {`View ${row.image.length} Image(s)`}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {(day[2].checked || day[3].checked) && (
          <table
            className="oocyte-embryo-table"
            cellPadding={'13px'}
            style={{ flexGrow: 1 }}
          >
            <thead>
              <tr>
                <th>
                  <div style={{ height: '244px' }}></div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div
                    style={{
                      height: '34px',
                      marginTop: '15px',
                      width: '135px',
                    }}
                  >
                    Blastocyst Culture
                  </div>
                </td>
              </tr>
              {oocyteData.day4.data.map((row, index) => (
                <tr key={index}>
                  <td>
                    {renderDropdownWithoutLabel(
                      `day4.data[${index}].blastocystCulture`,
                      row.blastocystCulture,
                      [' ', 'Yes', 'No'],
                      handleRowInputChange,
                      index,
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {day[3].checked && (
          <table
            className="oocyte-embryo-table"
            cellPadding={'20px'}
            style={{ flexGrow: 1, padding: '0px 10px' }}
          >
            <thead>
              <tr>
                <th colSpan={4}>Day 4</th>
              </tr>
              <tr>
                <th colSpan={1}>Date:</th>
                <th colSpan={3}>
                  <DateComponent
                    id="embryologyDate"
                    selectedDate={
                      oocyteData.day4.date ? dayjs(oocyteData.day4.date) : null
                    }
                    handleDateChange={(date, dateString) =>
                      handleDateChange(date, 'date', 4)
                    }
                  />
                </th>
              </tr>
              <tr>
                <th colSpan={4}>
                  <div style={{ height: '41px' }}></div>
                </th>
              </tr>
              <tr>
                <th colSpan={2}>Sci: </th>
                <th colSpan={2}>
                  {renderInputFieldWithoutLabel(
                    'day4.sci',
                    oocyteData.day4.sci,
                    handleInputChange,
                  )}{' '}
                </th>
              </tr>
              <tr>
                <th colSpan={1}>Witness: </th>
                <th colSpan={3}>
                  {renderInputFieldWithoutLabel(
                    'day4.witness',
                    oocyteData.day4.witness,
                    handleInputChange,
                  )}{' '}
                </th>
              </tr>
              <tr>
                <th colSpan={1}>Time:</th>
                <th colSpan={3}>
                  <TextField
                    type="time"
                    variant="standard"
                    value={oocyteData.day4.time}
                    onChange={(e) =>
                      handleTimeChange(e.target.value, 'time', 4)
                    }
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div
                    style={{
                      height: '40px',
                      marginTop: '15px',
                      width: '130px',
                    }}
                  >
                    Stage
                  </div>
                </td>
                <td>
                  <div style={{ width: '60px' }}>Grade</div>
                </td>
                <td>
                  <div style={{ width: '100px' }}>Comm</div>
                </td>
                <td>Image</td>
              </tr>
              {oocyteData.day4.data.map((row, index) => (
                <tr key={index}>
                  <td>
                    {renderDropdownWithoutLabel(
                      `day4.data[${index}].stage`,
                      row.stage,
                      [
                        ' ',
                        'Arrested',
                        '10+',
                        '10',
                        '9',
                        '8',
                        '7',
                        '6',
                        '5',
                        '4',
                        '3',
                        'Early Morula',
                        'Morula',
                        'Cavitating',
                        'Early  Blastocyst',
                      ],
                      handleRowInputChange,
                      index,
                    )}
                  </td>
                  <td>
                    {renderDropdownWithoutLabel(
                      `day4.data[${index}].grade`,
                      row.grade,
                      [' ', 'A', 'B', 'C'],
                      handleRowInputChange,
                      index,
                    )}
                  </td>
                  <td>
                    {renderInputFieldWithoutLabel(
                      `day4.data[${index}].comm`,
                      row.comm,
                      (e) => handleRowInputChange(e, index),
                    )}
                  </td>
                  <td>
                    <button
                      className="btn btn-primary"
                      style={{}}
                      onClick={() =>
                        setImageModal({ open: true, day: 4, index })
                      }
                    >
                      {`View ${row.image.length} Image(s)`}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {day[4].checked && (
          <table
            className="oocyte-embryo-table"
            cellPadding={'20px'}
            style={{ flexGrow: 1, padding: '0px 10px' }}
          >
            <thead>
              <tr>
                <th colSpan={7}>Day 5</th>
              </tr>
              <tr>
                <th colSpan={3}>Date:</th>
                <th colSpan={4}>
                  <DateComponent
                    id="embryologyDate"
                    selectedDate={
                      oocyteData.day5.date ? dayjs(oocyteData.day5.date) : null
                    }
                    handleDateChange={(date, dateString) =>
                      handleDateChange(date, 'date', 5)
                    }
                  />
                </th>
              </tr>
              <tr>
                <th colSpan={7}>
                  <div style={{ height: '41px' }}></div>
                </th>
              </tr>
              <tr>
                <th colSpan={3}>Sci:</th>
                <th colSpan={4}>
                  {renderInputFieldWithoutLabel(
                    'day5.sci',
                    oocyteData.day5.sci,
                    handleInputChange,
                  )}{' '}
                </th>
              </tr>
              <tr>
                <th colSpan={3}>Witness: </th>
                <th colSpan={4}>
                  {renderInputFieldWithoutLabel(
                    'day5.witness',
                    oocyteData.day5.witness,
                    handleInputChange,
                  )}{' '}
                </th>
              </tr>
              <tr>
                <th colSpan={3}>Time:</th>
                <th colSpan={4}>
                  <TextField
                    type="time"
                    variant="standard"
                    value={oocyteData.day5.time}
                    onChange={(e) =>
                      handleTimeChange(e.target.value, 'time', 5)
                    }
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div
                    style={{
                      height: '40px',
                      marginTop: '15px',
                      width: '130px',
                    }}
                  >
                    Stage
                  </div>
                </td>
                <td>Expansion</td>
                <td>
                  <div style={{ width: '90px' }}>Inner Cell Mass Grade</div>
                </td>
                <td>
                  <div style={{ width: '90px' }}>Trophectoderm Grade</div>
                </td>
                <td>
                  {' '}
                  <div style={{ width: '90px' }}>Overall Grade</div>
                </td>
                <td>
                  <div style={{ width: '100px' }}>Comm</div>
                </td>
                <td>Image</td>
              </tr>
              {oocyteData.day5.data.map((row, index) => (
                <tr key={index}>
                  <td>
                    {renderDropdownWithoutLabel(
                      `day5.data[${index}].stage`,
                      row.stage,
                      [
                        ' ',
                        'Arrested',
                        'Cleavage',
                        'Early Morula',
                        'Morula',
                        'Cavitating',
                        'Blastocyst',
                      ],
                      handleRowInputChange,
                      index,
                    )}
                  </td>
                  <td>
                    {renderDropdownWithoutLabel(
                      `day5.data[${index}].expansion`,
                      row.expansion,
                      [' ', '1', '2', '3', '4', '5', '6'],
                      handleRowInputChange,
                      index,
                    )}
                  </td>

                  <td>
                    {renderDropdownWithoutLabel(
                      `day5.data[${index}].innerCellMassGrade`,
                      row.innerCellMassGrade,
                      [' ', 'A', 'B', 'C'],
                      handleRowInputChange,
                      index,
                    )}
                  </td>
                  <td>
                    {renderDropdownWithoutLabel(
                      `day5.data[${index}].trophectodermGrade`,
                      row.trophectodermGrade,
                      [' ', 'A', 'B', 'C'],
                      handleRowInputChange,
                      index,
                    )}
                  </td>
                  <td>
                    {renderDropdownWithoutLabel(
                      `day5.data[${index}].overallGrade`,
                      row.overallGrade,
                      [' ', 'A', 'B', 'C'],
                      handleRowInputChange,
                      index,
                    )}
                  </td>
                  <td>
                    {renderInputFieldWithoutLabel(
                      `day5.data[${index}].comm`,
                      row.comm,
                      (e) => handleRowInputChange(e, index),
                    )}
                  </td>
                  <td>
                    <button
                      className="btn btn-primary"
                      style={{}}
                      onClick={() =>
                        setImageModal({ open: true, day: 5, index })
                      }
                    >
                      {`View ${row.image.length} Image(s)`}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {day[5].checked && (
          <table
            className="oocyte-embryo-table"
            cellPadding={'20px'}
            style={{ flexGrow: 1, padding: '0px 10px' }}
          >
            <thead>
              <tr>
                <th colSpan={8}>Day 6</th>
              </tr>
              <tr>
                <th colSpan={3}>Date:</th>
                <th colSpan={5}>
                  <DateComponent
                    id="embryologyDate"
                    selectedDate={
                      oocyteData.day6.date ? dayjs(oocyteData.day6.date) : null
                    }
                    handleDateChange={(date, dateString) =>
                      handleDateChange(date, 'date', 6)
                    }
                  />
                </th>
              </tr>
              <tr>
                <th colSpan={8}>
                  <div style={{ height: '41px' }}></div>
                </th>
              </tr>
              <tr>
                <th colSpan={3}>Sci:</th>
                <th colSpan={5}>
                  {renderInputFieldWithoutLabel(
                    'day6.sci',
                    oocyteData.day6.sci,
                    handleInputChange,
                  )}{' '}
                </th>
              </tr>
              <tr>
                <th colSpan={3}>Witness: </th>
                <th colSpan={5}>
                  {renderInputFieldWithoutLabel(
                    'day6.witness',
                    oocyteData.day6.witness,
                    handleInputChange,
                  )}{' '}
                </th>
              </tr>
              <tr>
                <th colSpan={3}>Time:</th>
                <th colSpan={5}>
                  <TextField
                    type="time"
                    variant="standard"
                    value={oocyteData.day6.time}
                    onChange={(e) =>
                      handleTimeChange(e.target.value, 'time', 6)
                    }
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div
                    style={{
                      height: '40px',
                      marginTop: '15px',
                      width: '130px',
                    }}
                  >
                    Stage
                  </div>
                </td>
                <td>Expansion</td>
                <td>
                  <div style={{ width: '90px' }}>Inner Cell Mass Grade</div>
                </td>
                <td>
                  <div style={{ width: '90px' }}>Trophectoderm Grade</div>
                </td>
                <td>
                  {' '}
                  <div style={{ width: '90px' }}>Overall Grade</div>
                </td>
                <td>
                  <div style={{ width: '100px' }}>Comm</div>
                </td>
                <td>Image</td>
                {/* {day[6].checked && (
                  <>
                    <td>
                      <div style={{ width: '160px' }}>Fate</div>
                    </td>
                    <td>
                      <div style={{ width: '100px' }}>Straw No.</div>
                    </td>
                    <td>
                      <div style={{ width: '160px' }}>Oocyte/Embryo Code</div>
                    </td>
                    <td>
                      <div style={{ width: '50px' }}>Day</div>
                    </td>
                    <td>
                      <div style={{ width: '100px' }}>Cell#/Grade</div>
                    </td>
                  </>
                )} */}
              </tr>
              {oocyteData.day6.data.map((row, index) => (
                <>
                  <tr key={index}>
                    <td>
                      {renderDropdownWithoutLabel(
                        `day6.data[${index}].stage`,
                        row.stage,
                        [
                          ' ',
                          'Arrested',
                          'Cleavage',
                          'Early Morula',
                          'Morula',
                          'Cavitating',
                          'Blastocyst',
                        ],
                        handleRowInputChange,
                        index,
                      )}
                    </td>
                    <td>
                      {renderDropdownWithoutLabel(
                        `day6.data[${index}].expansion`,
                        row.expansion,
                        [' ', '1', '2', '3', '4', '5', '6'],
                        handleRowInputChange,
                        index,
                      )}
                    </td>

                    <td>
                      {renderDropdownWithoutLabel(
                        `day6.data[${index}].innerCellMassGrade`,
                        row.innerCellMassGrade,
                        [' ', 'A', 'B', 'C'],
                        handleRowInputChange,
                        index,
                      )}
                    </td>
                    <td>
                      {renderDropdownWithoutLabel(
                        `day6.data[${index}].trophectodermGrade`,
                        row.trophectodermGrade,
                        [' ', 'A', 'B', 'C'],
                        handleRowInputChange,
                        index,
                      )}
                    </td>
                    <td>
                      {renderDropdownWithoutLabel(
                        `day6.data[${index}].overallGrade`,
                        row.overallGrade,
                        [' ', 'A', 'B', 'C'],
                        handleRowInputChange,
                        index,
                      )}
                    </td>
                    <td>
                      {renderInputFieldWithoutLabel(
                        `day6.data[${index}].comm`,
                        row.comm,
                        (e) => handleRowInputChange(e, index),
                      )}
                    </td>
                    <td>
                      <button
                        className="btn btn-primary"
                        style={{}}
                        onClick={() =>
                          setImageModal({ open: true, day: 6, index })
                        }
                      >
                        {`View ${row.image.length} Image(s)`}
                      </button>
                    </td>
                    {/* <>
                      {day === 'Full' && (
                        <>
                          <td>
                            {renderDropdownWithoutLabel(
                              `day6.data[${index}].fate`,
                              row.fate,
                              [
                                ' ',
                                'Embryo Transfer',
                                'Cryopreserve',
                                'Embryobiopsy',
                                'Discard',
                              ],
                              handleRowInputChange,
                              index,
                            )}
                          </td>
                          <td>
                            {renderInputFieldWithoutLabel(
                              `day6.data[${index}].strawNumber`,
                              row.strawNumber,
                              (e) => handleRowInputChange(e, index),
                            )}
                          </td>
                          <td>
                            {renderInputFieldWithoutLabel(
                              `day6.data[${index}].oocyteEmbryoCode`,
                              row.oocyteEmbryoCode,
                              (e) => handleRowInputChange(e, index),
                            )}
                          </td>
                          <td>
                            {renderInputFieldWithoutLabel(
                              `day6.data[${index}].day`,
                              row.day,
                              (e) => handleRowInputChange(e, index),
                            )}
                          </td>
                          <td>
                            {renderInputFieldWithoutLabel(
                              `day6.data[${index}].cellNoOrGrade`,
                              row.cellNoOrGrade,
                              (e) => handleRowInputChange(e, index),
                            )}
                          </td>
                        </>
                      )}
                    </> */}
                  </tr>
                </>
              ))}
            </tbody>
          </table>
        )}

        <table
          className="oocyte-embryo-table"
          style={{ flexGrow: 1 }}
          cellPadding={'3px'}
        >
          <thead>
            <tr>
              <th>
                <div style={{ height: '244px' }}></div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              {day[6].checked && (
                <>
                  <td>
                    <div
                      style={{
                        height: '35px',
                        marginTop: '15px',
                        width: '160px',
                      }}
                    >
                      Fate
                    </div>
                  </td>
                  <td>
                    <div style={{ width: '100px' }}>Straw No.</div>
                  </td>
                  <td>
                    <div style={{ width: '160px' }}>Oocyte/Embryo Code</div>
                  </td>
                  <td>
                    <div style={{ width: '50px' }}>Day</div>
                  </td>
                  <td>
                    <div style={{ width: '100px' }}>Cell#/Grade</div>
                  </td>
                </>
              )}
              <td>
                <div style={{ width: '90px', height: '19px' }}>Delete Row</div>
              </td>
            </tr>
            {oocyteData.day6.data.map((row, index) => (
              <tr key={index}>
                <>
                  {day[6].checked && (
                    <>
                      <td>
                        {renderDropdownWithoutLabel(
                          `day6.data[${index}].fate`,
                          row.fate,
                          [
                            ' ',
                            'Embryo Transfer',
                            'Cryopreserve',
                            'Embryobiopsy',
                            'Discard',
                          ],
                          handleRowInputChange,
                          index,
                        )}
                      </td>
                      <td>
                        {renderInputFieldWithoutLabel(
                          `day6.data[${index}].strawNumber`,
                          row.strawNumber,
                          (e) => handleRowInputChange(e, index),
                        )}
                      </td>
                      <td>
                        {renderInputFieldWithoutLabel(
                          `day6.data[${index}].oocyteEmbryoCode`,
                          row.oocyteEmbryoCode,
                          (e) => handleRowInputChange(e, index),
                        )}
                      </td>
                      <td>
                        {renderInputFieldWithoutLabel(
                          `day6.data[${index}].day`,
                          row.day,
                          (e) => handleRowInputChange(e, index),
                        )}
                      </td>
                      <td>
                        {renderInputFieldWithoutLabel(
                          `day6.data[${index}].cellNoOrGrade`,
                          row.cellNoOrGrade,
                          (e) => handleRowInputChange(e, index),
                        )}
                      </td>
                    </>
                  )}
                </>
                <td>
                  <IconButton
                    onClick={() => setConfirmModal({ open: true, index })}
                    size="small"
                    color="error"
                    disabled={oocyteData.day1.data.length === 1}
                  >
                    <DeleteIcon />
                  </IconButton>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="body">
        <button
          className="btn btn-primary mt-4"
          style={{ width: '200px' }}
          onClick={() => handleAddRow()}
        >
          Add Row
        </button>
      </div>

      {imageModal.open &&
        imageModal.day !== null &&
        imageModal.index !== null && (
          <EmbryologyOocyteImageModal
            show={imageModal.open}
            index={imageModal.index}
            day={imageModal.day}
            onClose={() => {
              setImageModal({ open: false, index: null, day: null });
            }}
          />
        )}
      <UIModal
        title="Please confirm?"
        body="Are you sure you want to delete this record?"
        proceedText="Confirm"
        cancelText="Cancel"
        show={confirmModal.open}
        onClose={() => setConfirmModal({ open: false, index: null })}
        onSave={() => {
          handleDeleteRow(confirmModal.index);
          setConfirmModal({ open: false, index: null });
        }}
      />
    </div>
  );
};

export default EmbryologyOocyteEmbryoRecord;
